// Module
var code = "<div class=\"value-column\"> <!-- ko foreach: $data._fieldValueEditors --> <!-- ko template: { html: $data.GetTemplate.bind($data), afterRender: $data.AfterRender.bind($data) } --><!-- /ko --> <!-- /ko --> </div> ";
// Exports
export default code;